import { Theme } from '@material-ui/core/styles';
import { createStyles, makeStyles } from '@material-ui/styles';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Bank } from '@/api/dictionary';
import { BanksSelection, Label, Space } from '@/components';
import { makeSelectIsMobileView } from '@/model/global/selectors';
import { InvoiceUIState } from '@/model/invoice/types';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    search: {
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
    },
    searchMobile: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  }),
);

interface BanksViewProps {
  value: Bank[];
}

const selectIsMobile = makeSelectIsMobileView();

export const BanksView: React.FC<BanksViewProps> = ({ value }: BanksViewProps) => {
  const history = useHistory();
  const classes = useStyles();
  const isMobile = useSelector(selectIsMobile);
  return (
    <Space direction="vertical" style={{ flexGrow: 1 }}>
      <Label className={isMobile ? classes.searchMobile : classes.search}>
        <FormattedMessage id="invoice.components.banks.title" />
      </Label>
      <BanksSelection
        value={value}
        onSelect={(id): void => history.push(`${InvoiceUIState.BANK}/${id}`)}
        searchClassName={isMobile ? classes.searchMobile : classes.search}
        bankItemClassName={isMobile ? classes.searchMobile : classes.search}
      />
    </Space>
  );
};

export default BanksView;
